import { http } from './config'

export default {

  getAllDivergenceLoadProducts: () => {
    return http.get('divergence_load_products')
  },
  getDivergenceLoadProductsGroupedByLoadId: (loadId) => {
    return http.get('divergence_load_products/divergences_grouped/' + loadId)
  },
  exportDivergenceReport: (loadId) => {
    return http.get('loads/' + loadId + '/export_divergence_report')
  },

}
